// extracted by mini-css-extract-plugin
export default {"chessboardWrapper":"ChessBoard_chessboardWrapper__TKPXt","chessboardContainer":"ChessBoard_chessboardContainer__8mhIc"};